import { useState } from "react";

import { useLanguage } from "../../contexts/LanguageContext";
import PricingModal from "../PricingModal/PricingModal";

export default function Price() {
  const { t } = useLanguage();
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);

  const handleClick = () => {
    setIsPricingModalOpen(true);
  };

  return (
    <>
      <PricingModal
        isOpen={isPricingModalOpen}
        onClose={() => setIsPricingModalOpen(false)}
      />
      <div className="overflow-hidden">
        <section
          id="pricing"
          className="package-section background-shape-right"
          style={{
            backgroundColor: "#FAFAF9",
            paddingTop: "50px",
          }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="section-heading text-center mb-5">
                  <span className="text-uppercase color-secondary sub-title">
                    {t("about.pricingComparison.title")}
                  </span>
                  <h2>{t("about.pricingComparison.subtitle")}</h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center mb-100">
              <div className="col-lg-4 col-md price-item-mobile">
                <div className="card text-center single-pricing-pack p-5">
                  <h5 className="mb-2">{t("about.pricingComparison.free")}</h5>
                  <div className="pricing-img mt-3 mb-4">
                    <img
                      src="assets/img/basic.svg"
                      alt="pricing img"
                      className="img-fluid"
                    />
                  </div>

                  <div className="card-body p-0">
                    <ul className="list-unstyled text-sm pricing-feature-list">
                      <li>{t("about.pricingComparison.freeValues.events")}</li>
                      <li>
                        {t("about.pricingComparison.freeValues.photosPerEvent")}
                      </li>
                      <li>
                        {t("about.pricingComparison.freeValues.eventDuration")}
                      </li>
                      <li>{t("about.pricingComparison.freeValues.support")}</li>
                    </ul>
                    <div className="py-4 border-0 pricing-header">
                      <div className="h1 text-center mb-0 color-secondary">
                        <span className="price font-weight-bolder">
                          {t("about.pricingComparison.freeValues.price")}
                        </span>
                      </div>
                    </div>
                    <a href="/events/dashboard" className="btn outline-btn">
                      {t("about.pricingComparison.freePlan")}
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md price-item-mobile">
                <div className="card text-center popular-price single-pricing-pack p-5">
                  <h5 className="mb-2">{t("about.pricingComparison.daily")}</h5>
                  <div className="pricing-img mt-3 mb-4">
                    <img
                      src="assets/img/standard.svg"
                      alt="pricing img"
                      className="img-fluid"
                    />
                  </div>

                  <div className="card-body p-0">
                    <ul className="list-unstyled text-sm pricing-feature-list">
                      <li>
                        {t("about.pricingComparison.eventPremiumValues.events")}
                      </li>
                      <li>
                        {t(
                          "about.pricingComparison.eventPremiumValues.photosPerEvent"
                        )}
                      </li>
                      <li>
                        {t(
                          "about.pricingComparison.eventPremiumValues.eventDuration"
                        )}
                      </li>
                      <li>
                        {t(
                          "about.pricingComparison.eventPremiumValues.support"
                        )}
                      </li>
                    </ul>
                    <div className="py-4 border-0 pricing-header">
                      <div className="h1 text-center mb-0 color-secondary">
                        <span className="price font-weight-bolder">
                          {t(
                            "about.pricingComparison.eventPremiumValues.price"
                          )}
                        </span>
                      </div>
                    </div>
                    <span onClick={handleClick} className="btn outline-btn">
                      {t("about.pricingComparison.purchaseNow")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md price-item-mobile">
                <div className="card text-center single-pricing-pack p-5">
                  <h5 className="mb-2">
                    {t("about.pricingComparison.premium")}
                  </h5>
                  <div className="pricing-img mt-3 mb-4">
                    <img
                      src="assets/img/unlimited.svg"
                      alt="pricing img"
                      className="img-fluid"
                    />
                  </div>

                  <div className="card-body p-0">
                    <ul className="list-unstyled text-sm pricing-feature-list">
                      <li>
                        {t("about.pricingComparison.premiumValues.events")}
                      </li>
                      <li>
                        {t(
                          "about.pricingComparison.premiumValues.photosPerEvent"
                        )}
                      </li>
                      <li>
                        {t(
                          "about.pricingComparison.premiumValues.eventDuration"
                        )}
                      </li>
                      <li>
                        {t("about.pricingComparison.premiumValues.support")}
                      </li>
                    </ul>
                    <div className="py-4 border-0 pricing-header">
                      <div className="h1 text-center mb-0 color-secondary">
                        <span className="price font-weight-bolder">
                          {t("about.pricingComparison.premiumValues.price")}
                        </span>
                      </div>
                    </div>
                    <span onClick={handleClick} className="btn outline-btn">
                      {t("about.pricingComparison.purchaseNow")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
